/* eslint-disable */
import { Button, Grid2, Modal, Paper, styled, Typography } from '@mui/material';
import React from 'react';
import { MdContentCopy } from 'react-icons/md';

import { alpha } from '@mui/material';

export const CopyBudgetModalStyled = styled(Paper)(({ theme }) => ({
  width: 500,
  height: 500,
  padding: 16,
  '& ul': {
    listStyle: 'none',
    fontFamily: theme.typography.body2.fontFamily,
    '& li': {
      margin: '10px 0',
      '& input': {
        visibility: 'hidden',
        height: 0,
        width: 0,
      },
      '& label': {
        cursor: 'pointer',
        display: 'inline-block',
        width: '100%',
        padding: '10px 0',
      },
      '& input:checked + label': {
        backgroundColor: alpha(theme.palette.primary.main, 0.7),
      },
    },
  },
}));

export const CopyBudgetModal = ({
  isCopyBudgetModalOpen,
  handleCloseCopyBudgetModal,
  constructionsToCopyBudget,
  handleCopyBudgetChange,
  handleImportNewBudget,
  budgetIDToCopy,
}) => {
  return (
    <Modal
      open={isCopyBudgetModalOpen}
      onClose={handleCloseCopyBudgetModal}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CopyBudgetModalStyled>
        <Grid2
          container
          direction="column"
          justifyContent="space-between"
          style={{ height: '100%' }}
        >
          <Grid2 item>
            <Typography variant="h2">Copiar orçamento</Typography>
            <Grid2 style={{ overflowY: 'scroll', height: 350 }}>
              {!constructionsToCopyBudget ? (
                <div>
                  <LinearProgress style={{ width: '80%' }} />
                </div>
              ) : (
                <ul>
                  <li>
                    <input
                      type="radio"
                      value={0}
                      name="copy-budget"
                      id="copy-budget-0"
                      onChange={handleCopyBudgetChange}
                    />
                    <label htmlFor="copy-budget-0">
                      TEMPLATE RESIDENCIAL 01
                    </label>
                  </li>
                  {constructionsToCopyBudget.map((option) => (
                    <li key={option.id}>
                      <input
                        type="radio"
                        value={option.id}
                        name="copy-budget"
                        id={`copy-budget-${option.id}`}
                        onChange={handleCopyBudgetChange}
                      />
                      <label htmlFor={`copy-budget-${option.id}`}>
                        {option.name}
                      </label>
                    </li>
                  ))}
                </ul>
              )}
            </Grid2>
          </Grid2>
          <Grid2
            item
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: 20,
            }}
          >
            <Button
              color="primary"
              variant="outlined"
              onClick={() => handleImportNewBudget(true)}
              startIcon={<MdContentCopy />}
              disabled={!budgetIDToCopy || budgetIDToCopy === '0'}
            >
              Itens e Valores
            </Button>
            <Button
              color="secondary"
              variant="contained"
              onClick={() => handleImportNewBudget(false)}
              startIcon={<MdContentCopy />}
              disabled={!budgetIDToCopy}
            >
              Somente Itens
            </Button>
          </Grid2>
        </Grid2>
      </CopyBudgetModalStyled>
    </Modal>
  );
};
